import { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { resolveTextSize, TextVariant } from "config/theme";
import {
  DEFAULT_TEXT_SIZE,
  TextSize,
  textSizeClasses,
} from "config/text-sizes";

type TextProps<T extends ElementType = "div"> = {
  size?: TextSize;
  variant?: TextVariant;
  as?: T;
  className?: string;
  children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "size" | "className" | "children">;

export const Text = <T extends ElementType = "div">({
  size,
  variant,
  as,
  className = "",
  children,
  ...rest
}: TextProps<T>) => {
  const Tag = (as ?? "div") as ElementType;
  const { mobile: baseSizeKey, desktop: lgSizeKey } = resolveTextSize({
    size,
    variant,
  });
  const baseClass =
    textSizeClasses[baseSizeKey] ?? textSizeClasses[DEFAULT_TEXT_SIZE];
  const lgClass =
    lgSizeKey && textSizeClasses[lgSizeKey]
      ? `lg:${textSizeClasses[lgSizeKey]}`
      : undefined;
  const merged = ["leading-tight", baseClass, lgClass, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={merged} {...rest}>
      {children}
    </Tag>
  );
};
